module.exports = __webpack_public_path__ + "img/bookmark-fill.3bca6ddb.svg";